import {
    AfterContentInit,
    ChangeDetectorRef,
    Component,
    ContentChild,
    EventEmitter,
    OnDestroy,
    Output
} from "@angular/core";
import {
    AbstractSelectEditControlComponent
} from "../../../edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {EditGridAddRowQuickSelectResults, EditGridAddRowService} from "../edit-grid-add-row.service";
import {Subscription} from "rxjs";
import {AnalyticsService} from "../../../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../../../analytics/analytic-event";

@Component({
    selector: "wbo-edit-grid-add-row-quick-add",
    templateUrl: "./edit-grid-add-row-quick-add.component.html"
})
export class EditGridAddRowQuickAddComponent implements AfterContentInit, OnDestroy {

    @ContentChild(AbstractSelectEditControlComponent) control: AbstractSelectEditControlComponent<any>;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    private subscriptions: Subscription = new Subscription();

    constructor(private editGridAddRowService: EditGridAddRowService, private changeDetectorRef: ChangeDetectorRef, private analyticsService: AnalyticsService) {
    }

    ngAfterContentInit(): void {
        if (this.control) {
            this.subscriptions.add(this.control.onSelect.subscribe((item) => {
                this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_QUICK_ADD);
                this.onSelect.next(item);
                this.editGridAddRowService.addQuickSelect(new EditGridAddRowQuickSelectResults(item));
                // incomplete
                setTimeout(() => this.control.value = null);
                this.changeDetectorRef.detectChanges();
            }));

            this.control.placeholder = "fui.search-control.label";
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
